import { render } from "./TasksListComponent.vue?vue&type=template&id=61790a4a"
import script from "./TasksListComponent.vue?vue&type=script&lang=js"
export * from "./TasksListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__